/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A generic representation of a verifiable crendential. [Terminology](https://www.w3.org/TR/vc-data-model/#dfn-credential).
 */
export interface Credential {
    /** A flavor specific representation of a verifiable crendential. */
    dataModel: Truvity.CredentialDataModel;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    holder?: string;
    /** The URI of a credential. */
    id: string;
    /** The URI of the credential issuer. */
    issuer: string;
    /** A list of linked credential references. */
    linkedCredentialRefs?: Truvity.LinkedRef[];
    /** A list of linked file references. */
    linkedFileRefs?: Truvity.LinkedRef[];
    /** A list of credential types. [Terminology](https://www.w3.org/TR/vc-data-model/#dfn-type). */
    type: string[];
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    validFrom: Date;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    validUntil?: Date;
}
